import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';

export default WithApp(function ModalCuotaVendedorPanettone(props) {
  const cuota = props.model;
  const periodo = moment(cuota.valueSearch?.Periodo).format('YYYY-MM');

  const [dataChanging, setDataChanging] = useState([]);
  const [zones, setZones] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [dataExcel, setDataExcel] = useState(undefined);
  const [dataImport, setDataImport] = useState({});

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }
  // base/supervisor-v2 trae los supervisores de la sede CON sus vendedores anidados.
  async function listSupervisors(codsede) {
    let response = await wsFindBy('base/supervisor-v2', { state: 'A', deleted: 'null', codsede: codsede });
    if (response.success) setSupervisors(response.data);
  }

  const sellers = supervisors.find(
    (sup) => String(sup.id) === String(dataChanging.base_supervisor_id)
  )?.sellers || [];

  useEffect(() => {
    if (zones.length > 0 && cuota.base_zone_id) {
      handleChange('base_zone_id', String(cuota.base_zone_id));
    }
  }, [zones]);

  useEffect(() => {
    if (supervisors.length > 0 && cuota.base_supervisor_id) {
      handleChange('base_supervisor_id', String(cuota.base_supervisor_id));
    }
  }, [supervisors]);

  useEffect(() => {
    if (sellers.length > 0 && cuota.base_seller_id) {
      handleChange('base_seller_id', String(cuota.base_seller_id));
    }
  }, [supervisors, dataChanging.base_supervisor_id]);

  useEffect(() => {
    if (cuota.open) {
      setDataChanging({});
      listZones();
      setDataExcel(undefined);
    }
  }, [cuota.open]);

  useEffect(() => {
    const sede = zones.find((z) => String(z.id) === String(dataChanging.base_zone_id));
    if (!sede?.code) {
      setSupervisors([]);
      return;
    }
    listSupervisors(sede.code);
  }, [dataChanging.base_zone_id, zones]);

  useEffect(() => {
    if (dataImport?.success) {
      setDataChanging([]);
      setDataExcel({
        success: dataImport.success,
        sellers: dataImport.data.map((item) => {
          return {
            base_zone_code: item.SEDE,
            SlpCode: item.VENDEDOR,
            quota: item.CUOTA,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      setDataExcel(undefined);
    }
  }, [dataImport]);

  return (
    <>
      <Modal
        title={`Nueva cuota de vendedor Panetones`}
        model={cuota}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataExcel?.success
            ? 'sale/panettone_seller/multiple'
            : 'sale/panettone_seller'
        }
        dataForce={
          dataExcel?.success
            ? { sellers: dataExcel?.sellers }
            : {
                base_zone_id: dataChanging.base_zone_id,
                base_supervisor_id: dataChanging.base_supervisor_id,
                base_seller_id: dataChanging.base_seller_id,
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={zones}
            getOptionLabel={(item) => `${item.description}`}
            renderInput={(params) => (
              <TextField {...params} label="Sede" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {
              handleChange('base_zone_id', item?.id);
              handleChange('base_supervisor_id', null);
              handleChange('base_seller_id', null);
              setDataImport(null);
            }}
            value={zones.find((zone) => String(zone.id) === String(dataChanging.base_zone_id)) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['SEDE', 'VENDEDOR']}
            sortDuplicate={['SEDE', 'VENDEDOR']}
            downTemplate={{
              fileNameDown: `${periodo}_Plantilla de cuota para vendedor panetones`,
              fields: ['SEDE', 'VENDEDOR', 'CUOTA'],
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {!dataImport?.success && dataChanging.base_zone_id ? (
          <>
            <Autocomplete
              disableClearable
              options={supervisors}
              getOptionLabel={(item) => `${item.name}`}
              renderInput={(params) => (
                <TextField {...params} label="Supervisor" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {
                handleChange('base_supervisor_id', item?.id);
                handleChange('base_seller_id', null);
              }}
              value={supervisors.find((sup) => String(sup.id) === String(dataChanging.base_supervisor_id)) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <Autocomplete
              disableClearable
              options={sellers}
              getOptionLabel={(item) => `${item.SlpName}`}
              renderInput={(params) => (
                <TextField {...params} label="Vendedor" margin="normal" fullWidth />
              )}
              onChange={(e, item) => { handleChange('base_seller_id', item?.id); }}
              value={sellers.find((sel) => String(sel.id) === String(dataChanging.base_seller_id)) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <TextField
              label="Cuota (unidades)"
              fullWidth
              type="number"
              name="quota"
              margin="normal"
              defaultValue={!!cuota ? cuota.quota : ''}
              required
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
